import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ISpellCheckResponse } from './spell-check.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SpellCheckApiService {
  private spellCheckAPIUrl = environment.conversions.baseUrl + '/api/v2/spellcheck';

  constructor(
    private http: HttpClient,
  ) { }

  public async validateSentence(langCode: string, words: string[]): Promise<ISpellCheckResponse[] | void>  {
    if (!words || !words.length) {
      return;
    }

    return (this.http.post(this.spellCheckAPIUrl,
      {
        words,
      },
      {
        headers:
        {
          Language: langCode
        }
      })).toPromise() as Promise<ISpellCheckResponse[]>;
  }
}
